import React from 'react';
import EmptyState from './EmptyState';

interface VenueEmptyStateProps {
  onAddVenue: () => void;
  className?: string;
}

const VenueEmptyState: React.FC<VenueEmptyStateProps> = ({ onAddVenue, className }) => {
  const venueIcon = (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
      <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
      <polyline points="9,22 9,12 15,12 15,22"/>
    </svg>
  );

  return (
    <EmptyState
      icon={venueIcon}
      title="Create Your First Venue"
      description="Get started by adding your first venue or location. This will allow you to track visits and gather valuable customer insights."
      action={{
        label: "Add Your First Venue",
        onClick: onAddVenue,
        variant: "primary"
      }}
      className={className}
    />
  );
};

export default VenueEmptyState;
